import axios from 'axios'
import config from './config'
import { Message, LoadingBar } from 'view-design'
import store from '@/store/index.js'
// 创建axios实例
const service = axios.create({
  baseURL: config.anpaiUrl, // api的base_url
  timeout: 10000// 请求超时时间
})

// request拦截器
service.interceptors.request.use(async config => {
  LoadingBar.start()
  config.method = 'post'
  const token = await store.dispatch('QueryToken')
  config.headers['token'] = token
  config.headers['content-type'] = 'application/json'
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    LoadingBar.finish()
    const res = response.data
    if (res.code === 0 || res.code === 200) {
      return res
    } else {
      // Message.error('查询为空')
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    LoadingBar.finish()
    Message.error('请求异常')
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/libs/request.js